/* eslint-disable no-nested-ternary */
import React from "react";
import { SocialPlatform } from "core/models";
import { Modal, FormElement } from "ui/components";
import { useFormValidation } from "ui/hooks/use-form-validation";
import styles from "./AddSocialSettingModal.module.scss";

interface Props {
    platform: SocialPlatform;
    onSave(settingName: string): void;
    onClose(): void;
}

const AddSocialSettingModal: React.FC<Props> = ({
    platform,
    onClose,
    onSave,
}: Props) => {
    const [uploadStatus, setUploadStatus] = React.useState<boolean>(false);

    const addSocialSettingForm = useFormValidation({
        settingName: {
            valid: false,
            touched: false,
            title: `${platform} account name`,
            value: "",
            errorMsg: "",
            rules: {
                required: true,
                minLength: 2,
            },
        },
    });

    const handleSave = (): void => {
        if (
            !addSocialSettingForm.formValid ||
            !addSocialSettingForm.formState.settingName.value
        ) {
            setUploadStatus(false);
            return;
        }
        setUploadStatus(true);
        onSave(addSocialSettingForm.formState.settingName.value.toString());
    };

    const getSaveButtonText = (): string => {
        if (uploadStatus) {
            return "Redirecting...";
        }
        if (!uploadStatus) {
            return "Connect";
        }
        return "Connect";
    };

    const modalContent = (
        <div className={styles.container}>
            <FormElement
                type="text"
                theme="light"
                id="newStreamTitle"
                title={
                    addSocialSettingForm.formState.settingName.title ||
                    "Social setting name"
                }
                onChange={(value) => {
                    addSocialSettingForm.inputChangeHandler(
                        "settingName",
                        value,
                    );
                }}
                defaultText="Add display name"
                fieldState={addSocialSettingForm.formState.settingName}
            />
        </div>
    );

    return (
        <Modal
            content={modalContent}
            lineColor="amber"
            onClose={onClose}
            theme="light"
            onSave={handleSave}
            saveButtonText={getSaveButtonText()}
            saveButtonDisabled={
                !addSocialSettingForm.formValid || uploadStatus !== false
            }
            title={`Add ${platform} Account`}
            icon="plus"
            takeContentSize
        />
    );
};

export default AddSocialSettingModal;
